import { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { CookieBanner } from '@/components/CookieBanner';
import { LoadingState } from '@/components/LoadingState';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { CallbackPage, SilentCallbackPage } from '@/pages/CallbackPage';
import { CockpitPage } from '@/pages/CockpitPage';
import { PlanListPage } from '@/pages/PlanListPage';
import { PlanWizardPage } from '@/pages/PlanWizardPage';
import { PlanEditorPage } from '@/pages/PlanEditorPage';
import { VergleichPage } from '@/pages/VergleichPage';
import { ExportPage } from '@/pages/ExportPage';
import { AdminPage } from '@/pages/AdminPage';
import { TraegerListPage } from '@/pages/TraegerListPage';
import { EinrichtungListPage } from '@/pages/EinrichtungListPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import {
  AGBPage,
  DatenschutzPage,
  ImpressumPage,
  LizenzPage,
} from '@/pages/legal/LegalPage';
import { useAuth } from '@/auth/AuthProvider';
import { setOn401Handler } from '@/auth/apiClient';

function ProtectedShell() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setOn401Handler(() => {
      navigate('/login', { replace: true });
    });
  }, [navigate]);

  if (isLoading) return <LoadingState height="60vh" />;
  if (!isAuthenticated) {
    void login();
    return <LoadingState height="60vh" />;
  }
  return <Layout />;
}

export function App() {
  return (
    <Suspense fallback={<LoadingState height="100vh" />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />
        <Route path="/auth/silent-callback" element={<SilentCallbackPage />} />
        {/* Pflicht-Seiten: ohne Login erreichbar */}
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/agb" element={<AGBPage />} />
        <Route path="/lizenz" element={<LizenzPage />} />
        <Route element={<ProtectedShell />}>
          <Route path="/" element={<CockpitPage />} />
          <Route path="/plaene" element={<PlanListPage />} />
          <Route path="/plaene/new" element={<PlanWizardPage />} />
          <Route path="/plaene/clone" element={<PlanWizardPage />} />
          <Route path="/plaene/:planId" element={<PlanEditorPage />} />
          <Route path="/vergleich" element={<VergleichPage />} />
          <Route path="/export" element={<ExportPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/traeger" element={<TraegerListPage />} />
          <Route path="/einrichtungen" element={<EinrichtungListPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
      <CookieBanner />
    </Suspense>
  );
}
